<template>
  <div>
    <div style="margin-bottom: 10px; margin-top: 10px; margin-left: 10px; width: 99%;">
      <div style="float: left">
        <el-button size="mini" type="danger" @click="submitFlow" style="color: #FFFFFF">提交审批</el-button>
        <el-button size="mini" @click="exportSalary()" type="warning" style="color: #FFFFFF">导出</el-button>
        <el-button size="mini" @click="calculateSalary()">生成薪资</el-button>
        <el-button size="mini" @click="search()">查询</el-button>

      </div>
      <div style="float: right; margin-right: 20px">

      </div>
    </div>

    <div>
      <el-descriptions :column="4" border size="mini">
        <el-descriptions-item label="薪资月份">
          <el-date-picker
            v-model="params.month"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份">
          </el-date-picker>
        </el-descriptions-item>
<!--        <el-descriptions-item label="所在项目">-->
<!--          <el-input size="mini" placeholder="" v-model="params.project" clearable></el-input>-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item label="所在项目">
          <el-select v-model="params.project_ids" placeholder="选择项目" multiple filterable>
            <el-option v-for="item in projectList" :key="item.id" :label="item.value" :value="item.id">{{item.value}}</el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="姓名">
          <el-input size="mini" placeholder="请输入姓名" v-model="params.name" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-select v-model="params.check_status" clearable placeholder="请选择">
            <el-option label="待提交" value="1"></el-option>
            <el-option label="审批中" value="2"></el-option>
            <el-option label="审核失败" value="100"></el-option>
            <el-option label="审核失败" value="101"></el-option>
            <el-option label="完成" value="1000"></el-option>
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div style="margin-top: 10px;">
    </div>

    <el-table ref="Table" :data="pageData.list" :cell-style="cellStayle" @selection-change="handleSelectionChange"  height="700">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column fixed prop="name" label="姓名" align="center" width="" fixed></el-table-column>
      <el-table-column prop="project" label="项目" align="center" width="180" fixed></el-table-column>
      <el-table-column prop="salary_year" label="发薪年份" align="center" width="50"></el-table-column>
      <el-table-column prop="salary_month" label="发薪月份" align="center" width="50"></el-table-column>
      <el-table-column prop="ought_to_attendance" label="应出勤" align="center" width="50"></el-table-column>
      <el-table-column prop="practical_attendance" label="实际出勤" align="center" width="50"></el-table-column>
      <el-table-column prop="salary_count_day" label="工资核算天数" align="center" width="50"></el-table-column>
      <el-table-column prop="normal_salary" label="正常工作时间工资" align="center" width=""></el-table-column>
      <el-table-column prop="fixed_overtime_salary" label="固定加班工资" align="center" width=""></el-table-column>
      <el-table-column prop="perf_salary" label="绩效工资" align="center" width=""></el-table-column>
      <el-table-column prop="actual_attendance_salary" label="实际出勤工资" align="center" width=""></el-table-column>
      <el-table-column prop="overtime_salary" label="加班费" align="center" width=""></el-table-column>
      <el-table-column prop="temperature_money" label="高温费" align="center" width=""></el-table-column>
      <el-table-column prop="festival_money" label="过节费" align="center" width=""></el-table-column>
      <el-table-column prop="internship_money" label="顶岗费" align="center" width=""></el-table-column>
      <el-table-column prop="other_money" label="其他奖励" align="center" width=""></el-table-column>
      <el-table-column prop="absence" label="考勤奖罚" align="center" width=""></el-table-column>
      <el-table-column prop="ought_to_salary" label="应发工资" align="center" width=""></el-table-column>
      <el-table-column prop="housing_provident_fund" label="住房公积金" align="center" width=""></el-table-column>
<!--      <el-table-column prop="agent_subtract_money_total" label="扣除金额" align="center" width=""></el-table-column>-->
      <el-table-column prop="social_security_money" label="社保费" align="center" width=""></el-table-column>
      <el-table-column prop="housing_provident_fund" label="公积金" align="center" width=""></el-table-column>
      <el-table-column prop="work_injury_insurance" label="工伤险" align="center" width=""></el-table-column>
      <el-table-column prop="income_tax" label="个人税" align="center" width=""></el-table-column>
      <el-table-column prop="other_subtract_money" label="其他扣款" align="center" width=""></el-table-column>
      <el-table-column prop="special_reward" label="特殊奖罚" align="center" width=""></el-table-column>
      <el-table-column prop="actual_salary" label="实发工资" align="center" width=""></el-table-column>
      <el-table-column prop="check_status" label="审批状态" align="center" width="">
        <template slot-scope="scope">
          <span v-if="scope.row.check_status == 0">待审核</span>
          <span v-if="scope.row.check_status == 1">待提交</span>
          <span v-if="scope.row.check_status == 2">审批中</span>
          <span v-if="scope.row.check_status == 100">审核失败</span>
          <span v-if="scope.row.check_status == 101">审批失败</span>
          <span v-if="scope.row.check_status == 1000">完成</span>
        </template>
      </el-table-column>
      <el-table-column prop="batch_number" label="批次号" align="center" width="150"></el-table-column>
      <el-table-column prop="remark" label="备注" align="center" width=""></el-table-column>
      <el-table-column label="操作" align="center" width="">
        <template slot-scope="scope">
          <span v-if="scope.row.check_status == 1">
            <el-button style="color: white" type="danger" @click="showEditBox(scope.row)">修改</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination background layout="total, prev, pager, next, jumper, sizes"  class="pagination"
                   :total="pageData.total"
                   :current-page="pageData.page"
                   :page-size="pageData.pageSize"
                   :page-sizes="[100, 200, 300, 500]"
                   @current-change="handleCurrentChange" @size-change="handleSizeChange"/>

    <el-dialog title="修改薪资" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div>
        <el-form ref="form" :model="editForm" label-width="80px" size="mini">
          <el-form-item label="加班费">
            <el-input v-model="editForm.overtime_salary"></el-input>
          </el-form-item>
          <el-form-item label="高温费">
            <el-input v-model="editForm.temperature_money"></el-input>
          </el-form-item>
          <el-form-item label="过节费">
            <el-input v-model="editForm.festival_money"></el-input>
          </el-form-item>
          <el-form-item label="顶岗费">
            <el-input v-model="editForm.internship_money"></el-input>
          </el-form-item>
          <el-form-item label="其他奖励">
            <el-input v-model="editForm.other_money"></el-input>
          </el-form-item>
          <el-form-item label="其他扣款">
            <el-input v-model="editForm.other_subtract_money"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="editForm.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureEdit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import moment from "moment";
import Http from "../common/Http";

export default {
  name: "SalaryOrigin",
  data() {
    return {
      pageData: {
        list: [],
        total: 0,
        pageSize: 100,
        page: 1
      },
      params: {
        month: '',
        project: '',
        name: '',
        check_status: '',
      },
      selectList: [],
      projectList: [],
      dialogVisible: false,
      editForm: {
        overtime_salary : 0,
        temperature_money : 0,
        festival_money : 0,
        internship_money : 0,
        other_money : 0,
        other_subtract_money : 0,
        remark : "",
      },
    }
  },
  created() {
    this.getList()
    this.getProjectList()
  },
  methods: {
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      let params = this.params;
      params['page'] = this.pageData.page
      params['pageSize'] = this.pageData.pageSize
      Http.get(Http.getPreBaseURL() + '/oa/Salary/salaryOriginList', params, res => {
        if (res.code === 0) {
          this.pageData.list = res.data.data;
          this.pageData.page = res.data.current_page;
          this.pageData.pageSize = res.data.per_page;
          this.pageData.total = res.data.total;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    handleCurrentChange(val) {
      this.pageData.page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.getList()
    },
    submitFlow() {
      let list = this.selectList;
      let ids = []
      if (list.length <= 0) {
        this.$message.error({
          message: "请选择需要审批的薪资！",
          type: "error",
        })
        return false
      }
      // 判断是否已经提交过审批的
      for (let i=0; i < list.length; i++) {
        ids.push(list[i]['id'])
        if (list[i]['check_status'] !== 1) {
          this.$message.error({
            message: list[i]['name'] + "已提交薪资审批！",
            type: "error",
          })
          return false
        }
      }

      let params = { ids : ids}
      let that = this
      Http.get(Http.getPreBaseURL() + "/oa/Salary/submitFlow", params, res => {
        if (res.code == 0) {
          // 跳转到流程审批
          that.$router.push({
            path: '/flow/FlowView',
            query: {
              'sheet_id': 40,
              'master_id': 38,
              'timeValue': Date.now(),
              'batch_number': res.data,
            }
          });
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },
    exportSalary() {
      let year = ""
      let month = ""
      let monthParam = this.params.month
      let project = this.params.project

      monthParam = monthParam.split("-")
      if (monthParam.length === 2) {
        year = monthParam[0];
        month = monthParam[1];
      }
      if (year === '' || month === '') {
        this.$message({
          message: '请输入年份和月份才能导出记录',
          type: 'error'
        });
        return false;
      }

      var params = {
        project: project,
        year: year,
        month: month,
        project_ids: this.params.project_ids
      }

      Http.get(Http.getPreBaseURL() + "/oa/PreUserSalary/exportSalary", params, res => {
        if (res) {
          window.open(Http.getPreBaseURL() + res.data)
          this.$message({
            message: '导出成功',
            type: 'success'
          });
        } else {
          this.$message.error({
            message: '导出失败',
            type: "error",
          });
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
    },
    // 打开修改薪资弹窗
    showEditBox(item) {
      this.editForm.overtime_salary = item.overtime_salary
      this.editForm.temperature_money = item.temperature_money
      this.editForm.festival_money = item.festival_money
      this.editForm.internship_money = item.internship_money
      this.editForm.other_money = item.other_money
      this.editForm.other_subtract_money = item.other_subtract_money
      this.editForm.id = item.id
      this.editForm.remark = item.remark
      this.dialogVisible = true
    },
    sureEdit() {
      Http.get(Http.getPreBaseURL() + "/oa/Salary/editOrigin", this.editForm, res => {
         if (res.code == 0) {
           this.$message({
             message: res.msg,
             type: 'success'
           });
           this.search()
         } else {
           this.$message.error({
             message: res.msg,
             type: "error",
           });
         }
        this.dialogVisible = false
      })
    },
    // 计算薪资
    calculateSalary() {
      if (this.params.month == "") {
        this.$message({
          message: '请选择生成月份',
          type: 'warning'
        });
        return false
      }
      this.$confirm('是否重新生成' + this.params.month + '工资?(旧的工资记录会被覆盖)', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // let params = {
        //   'month' : this.params.month,
        // }
        // console.info(2222)
        let params = this.params
        Http.get(Http.getPreBaseURL() + '/oa/Salary/calculate', params, res => {
          if (res.code === 1) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
          } else {
            this.$message.error({
              message: res.msg,
              type: "error",
            });
          }
        })
      });


    },
    // 获取项目列表
    getProjectList() {
      let that = this
      Http.get(Http.getPreBaseURL() + '/oa/user/projectList', {}, res => {
        if (res.code === 0) {
          that.projectList = res.data
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    cellStayle({row, column, rowIndex, columnIndex}) {
      if (column.label === '实际出勤工资') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '加班费') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '其他奖励') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '高温费') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '顶岗费') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '过节费') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '应发工资') {
        return 'background-color : #FFAAAA'
      }

      if (column.label === '住房公积金') {
        if (row.housing_provident_fund > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '扣除金额') {
        if (row.agent_subtract_money_total > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '社保费') {
        if (row.social_security_money > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '公积金') {
        if (row.housing_provident_fund > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '工伤险') {
        if (row.work_injury_insurance > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '个人税') {
        if (row.personal_income_tax > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '其他扣款') {
        if (row.other_subtract_money > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '实发工资') {
        return 'background-color : #FFAAAA'
      }
      if (column.label === '考勤奖罚' || column.label === '特殊奖罚') {
        return 'background-color : #e7d4c1'
      }
    },
  },
}

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/PreSalary/SalaryOrigin.vue